import type { ComponentProps } from 'react';
import { routes } from 'routes/routes';
import { Link } from 'ui';

type P = {
  userId: string;
} & Omit<ComponentProps<typeof Link>, 'to'>;

const UserLink = ({ children, effects, userId, ...rest }: P) => (
  <Link effects={{ focus: true, hover: true, radius: true, ...effects }} to={routes.members.detail(userId)} {...rest}>
    {children}
  </Link>
);

export default UserLink;
